import { type ReactNode } from 'react';

import { FairPlayWithTagLine } from './FairPlayWithTagLine';
import styles from './FooterLogos.module.css';

const FAIR_PLAY_HREF = 'https://www.fairplaysportsmedia.com/';

type FooterLogosProps = {
  logo: ReactNode;
};

export const FooterLogos = ({ logo }: FooterLogosProps) => {
  return (
    <div className={styles.footerLogos} data-testid="footer-logos">
      <div className={styles.logosGroup}>
        <a
          className={styles.ocLogoLink}
          data-testid="oc-logo-link"
          href="/"
          rel="noopener noreferrer"
          target="_blank"
          title="Oddschecker"
        >
          {logo}
        </a>
        <a
          className={styles.fairPlayLink}
          data-testid="fair-play-link"
          href={FAIR_PLAY_HREF}
          rel="noopener noreferrer"
          target="_blank"
          title="FairPlay Sports Media"
        >
          <FairPlayWithTagLine />
        </a>
      </div>
    </div>
  );
};
